import React from "react"

export default () => {
    return <div className="loading-animation"></div>
}
